import Vue from 'vue'
import Router from 'vue-router'
import BankTransfer from '@/views/BankTransfer.vue'
import AlipayTransfer from '@/views/AlipayTransfer.vue'
import WalletTransfer from '@/views/WalletTransfer.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/BankTransfer/:merchantOrderNo',
      name: 'BankTransfer',
      component: BankTransfer
    },
    {
      path: '/AlipayTransfer/:merchantOrderNo',
      name: 'AlipayTransfer',
      component: AlipayTransfer
    },
    {
      path: '/WalletTransfer/:merchantOrderNo',
      name: 'WalletTransfer',
      component: WalletTransfer
    }
  ]
})